import Markdown from '@components/v2/ui/Markdown/Markdown';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, type Theme } from '@mui/material';
import { HighlightMedia } from '../../services/modules/highlights/highlights.types';
import { formatDate } from '../../utils/dates';
import { HighlightsTestIds } from '../../utils/testIds/Highlights.testIds';

interface HighlightDetailsProps {
  title: string;
  publishedAt: string;
  text: string;
  media: HighlightMedia | null;
}

const MEDIA_STYLES = {
  width: '100%',
  aspectRatio: '16 / 9',
  objectFit: 'cover',
  borderRadius: (theme: Theme) => `${theme.shape.borderRadius2xl}px`,
  marginBottom: 2,
} as const;

const HighlightDetails = ({ title, publishedAt, text, media }: HighlightDetailsProps) => (
  <Box test-id={HighlightsTestIds.DETAILS}>
    {media?.type === 'video' && (
      <Box
        component="video"
        controls
        src={media.url}
        test-id={HighlightsTestIds.DETAILS_VIDEO}
        sx={MEDIA_STYLES}
      />
    )}

    {media?.type === 'image' && (
      <Box
        component="img"
        src={media.url}
        alt={title}
        test-id={HighlightsTestIds.DETAILS_IMAGE}
        sx={MEDIA_STYLES}
      />
    )}

    <Typography
      variant="caption"
      color="textSecondary"
      component="p"
      testId={HighlightsTestIds.DETAILS_PUBLISHED_AT}
      sx={{ marginBottom: 1 }}
    >
      {formatDate(publishedAt, 'PPP')}
    </Typography>

    <Box test-id={HighlightsTestIds.DETAILS_TEXT}>
      <Markdown>{text}</Markdown>
    </Box>
  </Box>
);

export default HighlightDetails;
